import { LinkedInCombination } from './ClassicCVHeaderData.types';

// Constants.
// -----------------------------------------------------------------------------
export const DEFAULT_LINKEDIN_COMBINATION: LinkedInCombination = 'none';
